import React, { useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'; // needed for drag/drop/select

const Calendar = () => {
  const [events, setEvents] = useState([]);

  const handleDateSelect = (selectInfo) => {
    let title = prompt('Enter event title');
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear selection

    if (title) {
      const newEvent = {
        id: String(events.length + 1),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      };
      setEvents([...events, newEvent]);
    }
  };

  const handleEventClick = (clickInfo) => {
    if (window.confirm(`Delete event '${clickInfo.event.title}'?`)) {
      setEvents(events.filter(event => event.id !== clickInfo.event.id));
    }
  };

  const handleEventChange = (changeInfo) => {
    const updatedEvent = changeInfo.event;
    setEvents(events.map(event =>
      event.id === updatedEvent.id
        ? { ...event, start: updatedEvent.startStr, end: updatedEvent.endStr }
        : event
    ));
  };

  return (
    <div style={{ padding: '50px' }}>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        initialView="dayGridMonth"
        editable={true}
        selectable={true}
        selectMirror={true}
        dayMaxEvents={true}
        events={events}
        select={handleDateSelect}
        eventClick={handleEventClick}
        eventChange={handleEventChange}
      />
    </div>
  );
};

export default Calendar;
